(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thistle-journal-shell"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-journal-cookie]').forEach(button => {
    button.addEventListener('click', async () => {
      const error = document.querySelector('[data-journal-cookie-error]');
      error.hidden = true;
      try {
        if (!window.privacyBanner?.showPreferences) {
          await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          });
        }
        await window.privacyBanner.showPreferences();
      } catch (_) { error.hidden = false; }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
